const flashOverlay = document.querySelector('.flash');

const flashEffect = () => {
  if (!flashOverlay.classList.contains('loaded')) {
    flashOverlay.classList.add('loaded')
  }
}

window.addEventListener('load', flashEffect);
